import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaChild, ISchemaFilter, ISchemaProperty } from "../Schema";
import { EntityNames } from "../../../../enums/EntityNames";
import { EntityViewTypes } from "../../../../enums/EntityViewTypes";
import { FilterTypes } from "../../../../enums/FilterTypes";
import { FilterMatchType } from "../../../../enums/FilterMatchType";
import SidePanelDisposalLineItem from "../../layout/SidePanel/layouts/SidePanelDisposalLineItem";

export const DisposalsLineItemsSchema: ISchema = {
    displayName: "Disposals",
    GetSidePanelComponent: (data, onViewPage) => <SidePanelDisposalLineItem data={data} onViewPage={onViewPage} />,
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'reference',
            displayName: 'Reference',
            type: PropertyTypes.string,
            key: false,
            descriptor: true,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'yearStart',
            displayName: 'Year Start',
            type: PropertyTypes.year,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            defaultDisplayValue: '--',
        } as ISchemaProperty,
        {
            name: 'yearEnd',
            displayName: 'Year End',
            type: PropertyTypes.year,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            defaultDisplayValue: '--',
        } as ISchemaProperty,
        {
            name: 'status',
            displayName: 'Status',
            type: PropertyTypes.status,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
    ],

    primaryFilter: {
        PropertyName: "Reference",
        displayName: "Search",
        type: FilterTypes.search,
        required: false,
        className: "width--full",
        matchType: FilterMatchType.Equal,
        propertyType: PropertyTypes.string,
        placeHolder: "Enter a packing box reference"
    } as ISchemaFilter,

    filters: [
        {
            PropertyName: "Status",
            entityName: "disposalLineItemStatuses",
            displayName: "Status",
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.int,
            showInTab: true
        } as ISchemaFilter,
        {
            PropertyName: "YearStart",
            displayName: "Year Start",
            type: FilterTypes.year,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.year,
            showInTab: true
        } as ISchemaFilter,
        {
            PropertyName: "YearEnd",
            displayName: "Year End",
            type: FilterTypes.year,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.year,
            showInTab: true
        } as ISchemaFilter,
    ] as ISchemaFilter[],

    children: [{ entityName: EntityNames.disposalLineItems, displayName: "Items", cantView: false, viewType: EntityViewTypes.list, enableFilters: true, navPropertyName: "RecallId", canAdd: false } as ISchemaChild,],
};
